import { createContext, useContext, useReducer, useEffect, useCallback } from 'react'
import { useRouter } from 'next/router'
import dynamic from 'next/dynamic';

const DynamicEditShippingAddressDrawer = dynamic(() => import('@/components/Account/EditShippingAddressDrawer/EditShippingAddressDrawer'));

export const EditShippingAddressDrawerContext = createContext()

function drawerReducer(state, action) {
  switch (action.type) {
    case 'update_subscription': {
      return {
        ...state,
        subscription: action.payload,
      }
    }
    case 'open_drawer': {
      return {
        ...state,
        isOpen: true,
        subscription: action.payload
      };
    }
    case 'close_drawer': {
      return {
        ...state,
        isOpen: false,
        activeProductHandle: null
      };
    }
    case 'add_box_data': {
      return {
        ...state,
        boxManager: action.payload
      };
    }
    default:
      return state;
  }
}

const initialState = {
  isOpen: false,
  subscription: null,
};

export function useEditShippingAddressDrawerContext() {
  return useContext(EditShippingAddressDrawerContext)
}

export function EditShippingAddressDrawerProvider({ children }) {

  const router = useRouter()
  const [state, dispatch] = useReducer(drawerReducer, initialState)
  const { isOpen, subscription } = state

  const openDrawer = (subscription) => {
    dispatch({ type: 'open_drawer', payload: subscription})
  }

  const updateSubscription = useCallback((subscription) => {
    dispatch({ type: 'update_subscription', payload: subscription})
  }, []);

  useEffect(() => {
    if (isOpen) document.querySelector('html').classList.add('disable-scroll')
    if (!isOpen) document.querySelector('html').classList.remove('disable-scroll')
  }, [isOpen])

  useEffect(() => {
    dispatch({ type: 'close_drawer' })
  }, [router])

  return (
    <EditShippingAddressDrawerContext.Provider value={{isOpen, currentOpenSubscription: subscription, openDrawer, updateSubscription, dispatch}}>
      {isOpen &&
        <DynamicEditShippingAddressDrawer subscription={subscription} />
      }
      {children}
    </EditShippingAddressDrawerContext.Provider>
  )
}
